import r from "./filter.js";
import t from "./negate.js";
import e from "./_cb.js";
function o(o, f, m) {
  return r(o, t(e(f)), m);
}
export { o as default };